import React, { useState, useEffect } from 'react';
import Navbar from './Navbar'; // Import your Navbar component here
import { app } from '../firebaseConfig';
import Cookies from 'js-cookie';
import { getDatabase, ref, onValue, set, child, update, push, remove } from 'firebase/database';
import ConfirmationPopUp from './ConfirmationPopUp';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const [data, setData] = useState({ Name: "", Email: "", Airport: "", Country: "" });
  const [profile, setProfile] = useState({})
  const [loading, setLoading] = useState(true);
  const db = getDatabase(app);
  const[confirmPopUp , setConfirmPopUp] = useState(false);
  let maneuverData = [];
  const navigate = useNavigate();
  console.log("Confirm pop up state " , confirmPopUp);
  //update user profile data
  const updateProfileData = () => {
    try {
      // console.log("Printing data in update section ", data);
      const updates = {};
      updates['/users/' + Cookies.get('userId')] = data;
      return update(ref(db), updates);
    }
    catch (error) {
      alert("Failed to update profile details.")
    }
  }

  const handleSave = () => {
    updateProfileData().
    then(() => {
      alert("Profile updated successfully")
      navigate('/leaderboard')
    })
    .catch(error => {
      alert("Failed to update profile details")
    })
  }

  const cancelProfileChanges = () => {
    console.log("printing details inside cancel profile changes.");
    setData(profile)
  }

 
  const handleConfirmPopUpState = () => {
    setConfirmPopUp(false);
  }

  useEffect(() => {
    const fetchData = () => {
      //read user profile data
      const dbRef = ref(db, `users/${Cookies.get('userId')}`);
      onValue(dbRef, (snapshot) => {
        const dataSet = snapshot.val();
        setData({
          Name: dataSet?.Name ? dataSet.Name : "",
          Email: dataSet?.Email ? dataSet.Email : "",
          Airport: dataSet?.Airport ? dataSet.Airport : "",
          Country: dataSet?.Country ? dataSet.Country : ""
        });
        setProfile({
          Name: dataSet?.Name ? dataSet.Name : "",
          Email: dataSet?.Email ? dataSet.Email : "",
          Airport: dataSet?.Airport ? dataSet.Airport : "",
          Country: dataSet?.Country ? dataSet.Country : ""
        });
        setLoading(false);
        // console.log("printing data from database in performance", dataSet);
      });
    };
    fetchData();
  }, [loading]);

  console.log("printing data from database in state", data);
  const [isProfileCreated, setIsProfileCreated] = useState(false);
  return (
    <div>
      <Navbar /> {/* Render the Navbar component */}
      <div className="min-h-screen p-6 bg-gray-100 flex items-center justify-center ">
        <div className="container max-w-screen-lg mx-auto">
          <div>
            <div className="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
              <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
                <div className="text-gray-600">
                  <p className="font-medium text-lg mt-8">Update Profile</p>
                  {/* <p>Please fill out all the fields.</p> */}
                </div>
                <div className="lg:col-span-2 mt-8">
                  <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-1 lg:grid-cols-1">
                    <div className="md:col-span-5">
                      <div>
                        <label htmlFor="full_name">Name</label>
                      </div>
                      <div>
                        <input type="text" name="full_name" id="full_name" className="h-10 border mt-3 rounded px-4 w-full bg-gray-50" value={data.Name ? data.Name : ""} onChange={(e) => setData({ ...data, Name: e.target.value })} />
                      </div>
                    </div>
                    <div className="md:col-span-5 mt-3">
                      <div>
                        <label htmlFor="home_airport">Home Airport</label>
                      </div>
                      <div>
                        <input type="text" name="home_airport" id="home_airport" className="h-10 border mt-3 rounded px-4 w-full bg-gray-50" value={data.Airport ? data?.Airport : ""} onChange={(e) => setData({ ...data, Airport: e.target.value })} />
                      </div>
                    </div>
                    <div className="md:col-span-5 mt-3">
                      <div>
                        <label htmlFor="country">Country</label>
                      </div>
                      <div>
                        <input type="text" name="country" id="country" className="h-10 border mt-3 rounded px-4 w-full bg-gray-50" value={data.Country ? data.Country : ""} onChange={(e) => setData({ ...data, Country: e.target.value })} />
                      </div>
                    </div>
                    <div className='flex  justify-center mt-6 mb-8 '>
                      <button
                        type="submit"
                        className="w-full text-white bg-gray-800 hover:bg-gray-700-700 focus:ring-4 focus:outline-none ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center bg-primary-600 hover:bg-primary-700 focus:ring-primary-800 lg:mr-6"
                        style={{ marginTop: "20px" }}
                        onClick={handleSave}
                      >
                        Save
                      </button>
                      <button
                        type="submit"
                        className="w-full text-white bg-red-600 hover:bg-gray-700-700 focus:ring-4 focus:outline-none ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center bg-primary-600 hover:bg-primary-700 focus:ring-primary-800 lg:ml-6"
                        style={{ marginTop: "20px" }}
                        onClick={cancelProfileChanges}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="w-full text-white bg-red-600 hover:bg-gray-700-700 focus:ring-4 focus:outline-none ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center bg-primary-600 hover:bg-primary-700 focus:ring-primary-800 lg:ml-12    sm:mt-3"
                        style={{ marginTop: "20px" }}
                        onClick={() => setConfirmPopUp(true)}
                      >
                        Delete Profile
                      </button>
                    </div>
                    {/* Add more form fields here */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {confirmPopUp && (<ConfirmationPopUp handleConfirmPopUpState = {handleConfirmPopUpState}/>)}
    </div>
  );
};

export default Profile;
